import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { capitalize } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { getResourceSizeColumnDef } from "../common/getResourceSizeColumnDef";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { FilteredS3ResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { lifecycleRulesColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/aws/s3-column-defs/lifecycleRulesColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const s3ColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Buckets", "provider_unique_identifier"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("s3"),

  resourceAccountColumnDef,

  getResourceMetricsColumnDef("All Requests", "all_request_sum", "s3"),

  getResourceCreationTimeColumnDef("Creation Date"),

  resourceTotalSpendColumnDef,

  getResourceSizeColumnDef(),

  {
    field: "resource.public_access",
    headerName: "Public Access",
    headerTooltip:
      "Cloudchipr checks ACLs and bucket policies to detect if Public Read or Public Write permissions are enabled.",
    cellRenderer: ({ data }: ICellRendererParams<FilteredS3ResourceItem>) => {
      if (!data) {
        return null;
      }

      const accessType = data?.resource?.public_access;

      const title = accessType
        ?.split("_")
        ?.map((word) => capitalize(word))
        ?.join(" ");

      return <TypographyWithTooltip variant="inherit" title={title ?? ""} />;
    },
  },

  lifecycleRulesColumnDef,

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
